import React from "react";
import { useTranslation } from "react-i18next";

const GroupSelector = ({
  searchFilters,
  setSearchFilters,
  isGroupDropdownOpen,
  setIsGroupDropdownOpen,
  groupSearchInput,
  setGroupSearchInput,
  productGroup,
  filteredGroupOptions,
  dropdownRef,
}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "fa"; // Check if language is Farsi
  const groupPageSearchInput = isRTL ? "groupPage-searchInput-ser-fa" : "groupPage-searchInput-ser";
  const groupPageSearchInput2 = isRTL
    ? "custom-select-dropdown-input-fa"
    : "custom-select-dropdown-input";
  const groupPageSearchInput3 = isRTL
    ? "custom-select-dropdown-item-fa"
    : "custom-select-dropdown-item";

  return (
    <div className="custom-select-container" ref={dropdownRef}>
      <div
        className={groupPageSearchInput}
        onClick={() => setIsGroupDropdownOpen(!isGroupDropdownOpen)}
      >
        {searchFilters.selectedGroupId === "all" || !searchFilters.selectedGroupId
          ? t("groupPage_select_group")
          : productGroup.find((g) => g.ProductGroupId === searchFilters.selectedGroupId)
              ?.ProductGroupENName || t("groupPage_select_group")}
        <span className="custom-select-dropdown-span">
        <img
          className="custom-select-dropdown-icon img-fluid"
          src={require("../../Images/public/arrow_down.svg").default}
          alt=""
        />
        </span>
      </div>
      {isGroupDropdownOpen && (
        <div className="custom-select-dropdown">
          <input
            type="text"
            className={groupPageSearchInput2}
            placeholder={t("groupPage_search_groups")}
            value={groupSearchInput}
            onChange={(e) => setGroupSearchInput(e.target.value)}
          />
          <div
            className={groupPageSearchInput3}
            style={{
              backgroundColor: searchFilters.selectedGroupId === "all" ? "#f0f0f0" : "white",
            }}
            onClick={() => {
              setSearchFilters((prev) => ({ ...prev, selectedGroupId: "all" }));
              setIsGroupDropdownOpen(false);
            }}
          >
            {t("groupPage_all_groups")}
          </div>
          {filteredGroupOptions.map((group) => (
            <div
              className="custom-select-dropdown-item"
              key={group.ProductGroupId}
              style={{
                backgroundColor:
                  searchFilters.selectedGroupId === group.ProductGroupId ? "#f0f0f0" : "white",
              }}
              onClick={() => {
                setSearchFilters((prev) => ({
                  ...prev,
                  selectedGroupId: group.ProductGroupId,
                }));
                setIsGroupDropdownOpen(false);
              }}
            >
              {group.ProductGroupENName}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GroupSelector;
